import z from 'zod';
import {firestoreTimestampToDateSchema} from '../_other/firestore/firestoreTimestampToDateSchema';
import {examModuleDbSchema} from './examModuleDbSchema';

/** Output schema for use (with id and createdAt as Date). */
export const examModuleSchema = examModuleDbSchema.omit({createdAt: true}).extend({
  id: z.string(),
  createdAt: firestoreTimestampToDateSchema,
});

export interface ExamModule extends z.infer<typeof examModuleSchema> {}
